import axios from "axios";
import * as Sentry from "@sentry/react";
import GLOBAL from "../context/global";
/**
 * TODO document -- why change the default behavior?
 */
const unauthorizedInterceptor = err => {
  if (err?.response?.status === 401 && !err?.config?.headers["Skip-Unauthorized-Interceptor"]) {
    console.warn("unauthorizedInterceptor - sending user to home page for login Fail from: "+err.request?.responseURL);
    return window.location.replace("/");
  } else if (err?.response) {
    // Log all other API errors to Sentry
    Sentry.captureException(err, {
      extra: {
        url: err.config?.url,
        status: err.response?.status,
        data: err.response?.data
      }
    });
  }
  return Promise.reject(err);
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// add our access token to all request headers if not already present
instance.interceptors.request.use(config => {
  if (!config.headers["Authorization"]) {
    // maybe test url and baseUrl, and only add if within our domain?
    if (GLOBAL.accessToken) {
      config.headers["Authorization"] = `Bearer ${GLOBAL.accessToken}`;
    } else {
      console.log("axios request - making without access token", config?.url);
    }
  }
  return config;
});

instance.interceptors.response.use(
  null, // onSuccess
  // TODO response => response.data, // TODO auto-unwrap response.data (would remove 287 duplicate bits of code!)
  unauthorizedInterceptor // onError
);

export default instance;
